<template>
	<div class="avatar"
		 :class="componentClass" :title="finalTitle">
		<v-avatar :size="size"
				  :rounded="rounded"
				  :color="color">
			<v-img v-if="user?.avatar" :src="user.avatar?.srcThumb" :lazy-src="user.avatar?.srcLazy"/>
			<span v-else-if="user" class="avatar__fi">{{ fi }}</span>
			<v-icon v-else :small="small">mdi-at</v-icon>
		</v-avatar>

		<div v-if="icon" class="avatar__icon" :class="iconClass">
			<v-icon color="white">{{ icon }}</v-icon>
		</div>

	</div>
</template>

<script>
import * as userUtils from "@/utils/user";

export default {
	name: "avatar",
	props: {
		user: {},
		small: {
			type: Boolean,
			default: false,
		},
		large: {
			type: Boolean,
			default: false
		},
		xLarge: {
			type: Boolean,
			default: false
		},
		rounded: {
			type: Boolean,
			default: false
		},
		selected: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: String,
			default: null,
		},
		iconColor: {
			type: String,
			default: null,
		},
		title: {
			type: String,
			default: null,
		}
	},
	data: () => ({}),
	computed: {
		color() {
			return this.user ? "grey lighten-3" : null;
		},
		size() {
			if (this.xLarge) return 48;
			if (this.large) return 32;
			if (this.small) return 22;
			return 24;
		},
		fi() {
			if (this.user.avatarName) return this.user.avatarName;
			return userUtils.fi(this.user);
		},
		finalTitle() {
			return this.title || userUtils.nick(this.user);
		},
		componentClass() {
			const c = [];
			if (this.selected) c.push("--selected");

			if (this.xLarge) c.push("--x-large");
			else if (this.large) c.push("--large");
			else if (this.small) c.push("--small");

			return c?.length > 0 ? c : null;
		},
		iconClass() {
			const c = [];
			if (this.iconColor) c.push(this.iconColor);
			else  c.push("grey");

			return c?.length > 0 ? c : null;
		}
	}
}
</script>

<style lang="scss">
.avatar {
	//width: 28px;
	//height: 28px;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	position: relative;
	//display: inline-flex;
	/*align-items: center;
	justify-content: center;*/

	/*&.--small {
		width: 20px;
		height: 20px;
	}*/

	&__fi {
		font-size: .55rem;
		color: $default-text-color;
	}

	&__icon {
		position: absolute;
		z-index: 1;
		left: -4px;
		bottom: -4px;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background-color: map-get($red, "lighten-1");
		display: flex;
		align-items: center;
		justify-content: center;

		.v-icon {
			font-size: 10px !important;
		}
	}

	&.--small {
		width: 22px;
		height: 22px;
	}

	&.--large {
		width: 32px;
		height: 32px;
	}

	&.--x-large {
		width: 48px;
		height: 48px;

		.avatar__fi {
			font-size: $font-size-1;
		}
	}

	&:after {
		content: "";
		position: absolute;
		z-index: 1;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		border-radius: 50%;
	}

	/*&.--highlighted {
		&:after {
			border: 2px solid map-get($red, "lighten-1");
		}
	}*/

	&.--selected {
		&:after {
			border: 2px solid map-get($blue, "lighten-1");
		}
	}

	.v-avatar {
		position: relative;
		overflow: hidden;
		text-transform: uppercase;
	}
}
</style>